// extracted by mini-css-extract-plugin
export default {"chip":"DashboardFilterChip_chip__5pHwZ","reset":"DashboardFilterChip_reset__Yz2n0","detail":"DashboardFilterChip_detail__0q3VT","clear":"DashboardFilterChip_clear__1qpi9"};